import React from "react";
import { motion } from "framer-motion";
import { Calendar, MapPin, ArrowRight, Users } from "lucide-react";
import "../css/herosection.css";
import eva from "../img/ingenieria/eva2.png";
import edwin from "../img/ingenieria/edwin2.png";
import carlos from "../img/ingenieria/carlos2.png";
import natividad from "../img/ingenieria/natividad2.png";

// Datos de ejemplo para los ponentes
const ponentesData = [
  { id: 1, src: eva, alt: "utpl" },
  { id: 2, src: edwin, alt: "Edwin" },
  { id: 3, src: carlos, alt: "Carlos" },
  { id: 4, src: natividad, alt: "Natividad" },
];

// Variantes de animación
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.2 },
  },
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { type: "spring", stiffness: 100, damping: 15 },
  },
};

const photoVariants = {
  hidden: { scale: 0.8, opacity: 0, x: -20 },
  visible: {
    scale: 1,
    opacity: 1,
    x: 0,
    transition: { type: "spring", stiffness: 120, damping: 12 },
  },
};

const HeroSection = () => {
  return (
    <>
      <div className="hero-container bg1">
        <main className="hero-main">
          {/* Lado Izquierdo: Ponentes */}
          <motion.div
            className="ponentes-section"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
          >
            <div className="photo-stack">
              {ponentesData.map((ponente) => (
                <motion.div
                  key={ponente.id}
                  variants={photoVariants}
                  whileHover={{ y: -10, scale: 1.1, zIndex: 50 }}
                  className="photo-wrapper"
                >
                  <img
                    src={ponente.src}
                    alt={ponente.alt}
                    className="ponente-img"
                  />
                </motion.div>
              ))}
              <motion.div variants={photoVariants} className="photo-wrapper">
                <div className="users-icon-badge">
                  <Users size={32} color="white" />
                </div>
              </motion.div>
            </div>

            <motion.a
              href="#ponentes"
              variants={itemVariants}
              className="link-ponentes"
            >
              Conoce nuestros ponentes destacados
              <ArrowRight className="arrow-icon" size={20} />
            </motion.a>
          </motion.div>

          {/* Lado Derecho: Contenido */}
          <motion.div
            className="content-section"
            initial="hidden"
            animate="visible"
            variants={containerVariants}
          >
            <div className="tag-list">
              <motion.div variants={itemVariants} className="tag-item">
                <Calendar className="tag-icon" />
                <span>9,10 y 11 noviembre de 2026</span>
              </motion.div>

              <motion.div variants={itemVariants} className="tag-item">
                <MapPin className="tag-icon" />
                <span>Centro de convenciones UTPL, Loja</span>
              </motion.div>
            </div>

            <motion.h1 variants={itemVariants} className="hero-title">
              Ingeniería Estructural:
              <span className="title-gradient">
                Cimientos de un futuro sostenible
              </span>
            </motion.h1>

            <motion.p variants={itemVariants} className="hero-description">
              Buscamos integrar la innovación y la resiliencia en el desarrollo
              constructivo de la región. Únete a líderes mundiales para explorar
              la vanguardia en diseño y rehabilitación de infraestructuras
              críticas.
            </motion.p>

            <motion.div variants={itemVariants} className="cta-group">
              <a className="btn-primary" href="#preregistro">Realiza tu pre-registro</a>
          
            </motion.div>
          </motion.div>
        </main>
      </div>
    </>
  );
};

export default HeroSection;
